module.exports = __webpack_public_path__ + "fromBrideToParents-we-b.a37a9ac7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/fromBrideToParents-we-b.jpg
// module id = v2Aj
// module chunks = 0